import type {SVGProps} from 'react';
import * as React from 'react';
export const ArrowRightIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 13"
		{...props}
	>
		<g>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={1.5}
				d="M.797 6.5h10.406m0 0-4.856 4.856M11.203 6.5 6.347 1.644"
			/>
		</g>
	</svg>
);
